
import React, { useState } from 'react'
import { FiShield, FiCheckCircle } from 'react-icons/fi'

import { button } from './ResetButton.module.scss'

export const ResetButton = ({
  id,
  children
}) => {
  const [isReset, setIsReset] = useState(false)
  const ids = id.split(',')

  // remove all items with the given ids
  const resetLocalStorage = () => {
    // for every ID
    ids.forEach(id => {
      // check if local storage is a thing
      if (window && window.localStorage) {
        // find all keys in local storage
        Object.keys(window.localStorage).forEach(key => {
          // if the key starts with the ID, remove it
          if (key.startsWith(`com.box.developer.${id}`)) {
            window.localStorage.removeItem(key)
          }
        })
      }
    })

    // change the icon and color
    setIsReset(true)
  }
  
  return (
    <div className={button} data-is-reset={isReset}>
      <a onClick={resetLocalStorage}>
        { isReset ? <FiCheckCircle /> : <FiShield />}
        { children }
      </a>
    </div>
  )
}

export default ResetButton
